import * as React from "react";
import { useController, UseControllerProps } from "react-hook-form";

export type SpecFormValue = {
  Key: string;
  Value: string;
};

export function Input(
  props: UseControllerProps<SpecFormValue> & {
    hidden?: boolean;
    children?: React.ReactNode;
    style?: React.CSSProperties;
  }
) {
  const { field, fieldState } = useController(props);

  return (
    <div>
      {
        <input
          {...field}
          value={field.value || ""}
          hidden={props.hidden}
          placeholder={props.name}
        />
      }
      {props.children}
      {fieldState.error && (
        <p style={{ marginTop: "0" }}>{fieldState.error.message}</p>
      )}
    </div>
  );
}
